/*@ngInject*/
const ModalUtil = function ($rootScope, $uibModal, $state, $q, coreMediator, coreConstant, localization, loadingBarHandler, submissionConstant) {

    let serverDisconnectedModalDisplayed = false;

    this.showConfirmationModal = function (submissionId, quoteId, notificationEmailTemplateName, translationRoot, logAction, hideLoadingBar, callbackOnClose) {
        localization.getTranslations().then(function (root) {
            var translations = _.get(root, translationRoot),
                context = {};
            if (notificationEmailTemplateName) {
                if (submissionId) {
                    context.submissionId = submissionId;
                }
                if (quoteId) {
                    context.quoteId = quoteId;
                }
                coreMediator.getNotificationEmailTemplate(notificationEmailTemplateName, context).then(show);
            } else {
                show();
            }

            function show(notificationPreference) {
                let modalInstance = $uibModal.open({
                    templateUrl: '/ui/modal/modal.tpl.html',
                    controller: 'modalController',
                    backdrop: 'static',
                    windowClass: 'genericModal',
                    resolve: {
                        options: {
                            cancelButtonLabel: _.get(translations, 'cancel'),
                            confirmActionButtonLabel: _.get(translations, 'confirm'),
                            summary: _.get(translations, 'summary'),
                            title: notificationPreference && !_.isNil(notificationPreference.title) ? notificationPreference.title : _.get(translations, 'title')
                        }
                    }
                });
                modalInstance.result.then(handleClose);
            }

            function handleClose(result) {
                let callbackPromise;
                if (!hideLoadingBar) {
                    loadingBarHandler.showLoadingBar(translationRoot + '.loadingBar');
                }
                startPerformanceLog(logAction, submissionId);

                $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);

                callbackPromise = callbackOnClose(result);
                if (!_.isNil(callbackPromise)) {
                    callbackPromise.then(onSuccess, onError);
                }

                function onSuccess() {
                    loadingBarHandler.hideLoadingBar();
                    $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
                    stopPerformanceLog(logAction, coreConstant.uiPeformanceLogger.SUCCESS);
                }

                function onError() {
                    loadingBarHandler.hideLoadingBar();
                    stopPerformanceLog(logAction, coreConstant.uiPeformanceLogger.FAIL);
                }
            }
        });
    };

    this.showProposalBindActionModal = function (submissionId, proposalId, translationRoot, notificationName, logAction, callBack) {
        localization.getTranslations().then(function (root) {
            var translations = _.get(root, translationRoot);

            if (notificationName) {
                coreMediator.getNotificationPreference(notificationName, {
                    submissionId: submissionId.toString(),
                    proposalId: proposalId,
                    link: null
                }).then(show);
            } else {
                show();
            }

            function show(notificationPreference) {
                let dynamicDataSetParams = {
                    name: _.get(translations, 'dataSet'),
                    submissionUri: 'com.firstbest.underwriting.submission.Submission:' + submissionId,
                    ownerUri: 'com.firstbest.underwriting.proposal.Proposal:' + proposalId
                };

                coreMediator.getDynamicDataSetItems(dynamicDataSetParams).then(function (response) {

                    let modalInstance = $uibModal.open({
                        templateUrl: '/wizard/actions/bindActions/bindActionModal.tpl.html',
                        controller: 'bindActionModalController',
                        backdrop: 'static',
                        windowClass: 'bindActionModal',
                        resolve: {
                            options: function () {
                                return {
                                    quoteList: response,
                                    translationRoot: translationRoot,
                                    notificationPreference: notificationPreference
                                };
                            }
                        }
                    });

                    modalInstance.result.then(function (options) {
                        bindActionContinue(callBack, submissionId, logAction, translationRoot, proposalId, options.selectedQuoteIds);
                    });
                });
            }
        });
    };

    function bindActionContinue(callBack, submissionId, logAction, translationRoot, proposalId, quoteIds) {

        startPerformanceLog(logAction, submissionId);
        loadingBarHandler.showLoadingBar(translationRoot + '.loadingBar');
        callBack(proposalId, quoteIds).then(onSuccess, onError).finally(onFinally);

        function onSuccess(response) {
            stopPerformanceLog(logAction, coreConstant.uiPeformanceLogger.SUCCESS);
        }

        function onError() {
            stopPerformanceLog(logAction, coreConstant.uiPeformanceLogger.FAIL);
        }

        function onFinally() {
            loadingBarHandler.hideLoadingBar();
        }

    }

    this.showSelectionModal = function (submissionId, quoteId, proposalId, translationRoot, logAction, callbackOnClose) {
        localization.getTranslations().then(function (root) {
            let translations = _.get(root, translationRoot);
            let modalInstance = $uibModal.open({
                templateUrl: '/wizard/selection/selectionModal.tpl.html',
                controller: 'selectionModalController',
                backdrop: 'static',
                windowClass: 'selectionModalContainer',
                resolve: {
                    selectionDropdown: function () {
                        let uri;
                        if (!_.isNil(quoteId)) {
                            uri = quoteId ? 'com.firstbest.underwriting.quote.Quote:' + quoteId : null;
                        }
                        if (!_.isNil(proposalId)) {
                            uri = proposalId ? 'com.firstbest.underwriting.proposal.Proposal:' + proposalId : null;
                        }
                        return {
                            name: _.get(translations, 'dataSet'),
                            submissionUri: 'com.firstbest.underwriting.submission.Submission:' + submissionId,
                            ownerUri: uri
                        };
                    },

                    options: function () {
                        return {
                            title: _.get(translations, 'title'),
                            summary: _.get(translations, 'summary'),
                            confirm: _.get(translations, 'confirmButton'),
                            warningSummary: _.get(translations, 'warningSummary'),
                            selectedPrimaryPrompt: _.get(translations, 'primaryPrompt')
                        };
                    }
                }
            });
            modalInstance.result.then(handleClose);

            function handleClose(result) {
                let callbackPromise;
                loadingBarHandler.showLoadingBar(translationRoot + '.loadingBar');
                startPerformanceLog(logAction, submissionId);

                $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);

                callbackPromise = callbackOnClose(result);
                if (!_.isNil(callbackPromise)) {
                    callbackPromise.then(onSuccess, onError);
                }

                function onSuccess(result) {
                    loadingBarHandler.hideLoadingBar();
                    stopPerformanceLog(logAction, coreConstant.uiPeformanceLogger.SUCCESS);
                }

                function onError() {
                    loadingBarHandler.hideLoadingBar();
                    stopPerformanceLog(logAction, coreConstant.uiPeformanceLogger.FAIL);
                }
            }
        });
    };

    this.showUserProfile = function () {
        $uibModal.open({
            templateUrl: '/ui/modal/userProfileModal/userProfileModal.tpl.html',
            controller: 'userProfileModalController',
            backdrop: 'static',
            windowClass: 'userProfileModal'
        });
    };

    this.showFieldDetails = function (fieldStructure, formStructure) {
        $uibModal.open({
            templateUrl: '/formViewer/component/directive/uiShowFieldDetailsModal/fieldDetailsModal.tpl.html',
            controller: 'fieldDetailsModalController',
            backdrop: 'static',
            windowClass: 'fieldDetailsModalContainer',
            resolve: {
                options: function () {
                    return {
                        fieldStructure: fieldStructure,
                        formStructure: formStructure
                    };
                }
            }
        });
    };

    this.showHiddenFieldDetails = function (hiddenFieldList) {
        $uibModal.open({
            templateUrl: '/formViewer/component/directive/uiHiddenFieldDetailsModal/hiddenFieldDetailsModal.tpl.html',
            controller: 'hiddenFieldDetailsModalController',
            backdrop: 'static',
            windowClass: 'hiddenFieldDetailsModalContainer',
            resolve: {
                options: function () {
                    return {
                        formHiddenFieldList: hiddenFieldList
                    };
                }
            }
        });
    };

    this.showGenericConfirm = function (translations) {
        let modalInstance = $uibModal.open({
            templateUrl: '/ui/modal/modal.tpl.html',
            controller: 'modalController',
            backdrop: 'static',
            windowClass: 'genericModal',
            resolve: {
                options: function () {
                    return {
                        cancelButtonLabel: translations.cancelButtonLabel,
                        showCancelButton: translations.showCancelButton,
                        confirmActionButtonLabel: translations.confirmActionButtonLabel,
                        alternateButtonLabel: translations.alternateButtonLabel,
                        summary: translations.summary,
                        customButtonType: translations.customButtonType,
                        customButtons: translations.customButtons,
                        title: translations.title
                    };
                }
            }
        });
        return modalInstance.result;
    };

    this.showCustomAlertModal = function (translations, submission) {
        let modalInstance = $uibModal.open({
            templateUrl: '/ui/modal/modal.tpl.html',
            controller: 'modalController',
            backdrop: 'static',
            windowClass: 'genericModal',
            resolve: {
                options: function () {
                    return {
                        summary: translations.summary,
                        customButtonType: translations.customButtonType,
                        customButtons: translations.customButtons,
                        title: translations.title,
                        submission: submission,
                        contextParameters : translations.contextParameters
                    };
                }
            }
        });
        return modalInstance.result;
    };

    this.showEmailViewer = function (email, forwardCallback, replyCallback, replyAllCallback, saveEmailCallback, deleteEmailCallback, isUnderwriterUser, canCreateEmail, canDeleteEmail) {
        return $uibModal.open({
            templateUrl: '/collaboration/email/emailViewer/emailViewerModal.tpl.html',
            controller: 'emailViewerModalController',
            backdrop: 'static',
            windowClass: 'emailViewerModal',
            resolve: {
                options: function () {
                    return {
                        email: email,
                        isUnderwriterUser: isUnderwriterUser,
                        canCreateEmail: canCreateEmail,
                        canDeleteEmail: canDeleteEmail,
                        forwardEmail: forwardCallback,
                        replyEmail: replyCallback,
                        replyAllEmail: replyAllCallback,
                        saveEmail: saveEmailCallback,
                        deleteEmail: deleteEmailCallback
                    };
                }
            }
        });
    };

    this.showCommentsModal = function (submissionId, comments, options, translationRoot, logAction, callbackOnClose) {
        localization.getTranslations().then(function (root) {
            let translations = _.get(root, translationRoot);

            $uibModal.open({
                templateUrl: '/ui/modal/commentsModal/commentsModal.tpl.html',
                controller: 'commentsModalController',
                backdrop: 'static',
                windowClass: 'commentsModalContainer',
                resolve: {
                    options: function () {
                        return {
                            title: options.title ? options.title : _.get(translations, 'title'),
                            summary: options.summary || options.summary === null ? options.summary : _.get(translations, 'summary'),
                            label: options.label ? options.label : _.get(translations, 'label'),
                            comments: comments,
                            cancel: options.cancel ? options.cancel : _.get(translations, 'cancel'),
                            primaryAction: options.primaryAction ? options.primaryAction : _.get(translations, 'primaryAction'),
                            secondaryAction: options.secondaryAction ? options.secondaryAction : _.get(translations, 'secondaryAction'),
                            showSecondaryAction: options.showSecondaryAction
                        };
                    }
                }
            }).result.then(handleClose);

            function handleClose(result) {
                let loadingBar,
                    callbackPromise;

                if (result.primaryAction) {
                    loadingBar = options.primaryActionLoadingBar ? options.primaryActionLoadingBar : _.get(translations, 'primaryActionLoadingBar');
                } else if (result.secondaryAction) {
                    loadingBar = options.secondaryActionLoadingBar ? options.secondaryActionLoadingBar : _.get(translations, 'secondaryActionLoadingBar');
                }

                loadingBarHandler.showLoadingBar(loadingBar);
                startPerformanceLog(logAction, submissionId);

                $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);

                callbackPromise = callbackOnClose(result);
                if (!_.isNil(callbackPromise)) {
                    callbackPromise.then(onSuccess, onError);
                }

                function onSuccess() {
                    loadingBarHandler.hideLoadingBar();
                    $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
                    stopPerformanceLog(logAction, coreConstant.uiPeformanceLogger.SUCCESS);
                }

                function onError() {
                    loadingBarHandler.hideLoadingBar();
                    stopPerformanceLog(logAction, coreConstant.uiPeformanceLogger.FAIL);
                }
            }
        });
    };

    this.showNewAttachmentModal = function (existingFile, fullOptionsForm) {
        let instance = $uibModal.open({
            templateUrl: '/newAttachmentModal/newAttachmentModal.tpl.html',
            controller: 'newAttachmentModalController',
            backdrop: 'static',
            windowClass: 'newAttachmentModal',
            resolve: {
                options: function () {
                    return {};
                },
                isUnderwriterUser: function () {
                    return coreMediator.loadUserProfile().then(function (userProfile) {
                        return userProfile.userType === 'Underwriter';
                    });
                },
                fullOptionsForm: function () {
                    return fullOptionsForm;
                },
                existingFile: function () {
                    return existingFile;
                }
            }
        });

        return instance.result;
    };

    this.showAttachmentsListModal = function (attachmentList) {
        let instance = $uibModal.open({
            templateUrl: '/wizard/addDocumentAction/addDocumentActionModal.tpl.html',
            controller: 'addDocumentActionModalController',
            backdrop: 'static',
            windowClass: 'addDocumentActionModal',
            resolve: {
                attachments: function () {
                    return attachmentList;
                }
            }
        });

        return instance.result;
    };

    this.showActionNotImplementedModal = function (actionName) {
        localization.getTranslations().then(function (translations) {
            $uibModal.open({
                templateUrl: '/ui/modal/errorModal/errorModal.tpl.html',
                controller: 'errorModalController',
                backdrop: 'static',
                windowClass: 'genericErrorModal',
                resolve: {
                    options: {
                        title: _.get(translations, 'alert.genericErrorTitle'),
                        message: _.get(translations, 'alert.unableToRouteAction') + actionName,
                        okButtonLabel: _.get(translations, 'alert.okButtonLabel')
                    }
                }
            });
        });
    };

    this.openFieldReferencesModal = function (translationRoot, fieldReferences, variableName, showConfirmationButtons) {
        return localization.getTranslations().then(function (root) {
            let instance,
                translations = _.get(root, translationRoot),
                summary = _.get(translations, 'summary');

            summary = _.replace(summary, '{referencesCount}', fieldReferences.length);
            summary = _.replace(summary, '{variableName}', variableName);

            instance = $uibModal.open({
                templateUrl: '/configuration/fieldReferences/fieldReferencesModal.tpl.html',
                controller: 'fieldReferencesController',
                backdrop: 'static',
                windowClass: 'fieldReferencesModal',
                resolve: {
                    options: function () {
                        return {
                            title: _.get(translations, 'title'),
                            summary: summary,
                            confirmButtonLabel: _.get(translations, 'confirmButtonLabel'),
                            cancelButtonLabel: _.get(translations, 'cancelButtonLabel'),
                            showConfirmationButtons: showConfirmationButtons,
                            variableName: variableName,
                            fieldReferenceList: fieldReferences
                        };
                    }
                }
            });
            return instance.result;
        });
    };

    this.openFormReferencesModal = function (translationRoot, formTemplateReferences, formTemplateUniqueName, showConfirmationButtons) {
        return localization.getTranslations().then(function (root) {
            let instance,
                translations = _.get(root, translationRoot),
                summary = _.get(translations, 'summary');

            summary = _.replace(summary, '{referencesCount}', formTemplateReferences.length);
            summary = _.replace(summary, '{formTemplateUniqueName}', formTemplateUniqueName);

            instance = $uibModal.open({
                templateUrl: '/configuration/formReferences/formReferencesModal.tpl.html',
                controller: 'formReferencesController',
                backdrop: 'static',
                windowClass: 'formReferencesModal',
                resolve: {
                    options: function () {
                        return {
                            title: _.get(translations, 'title'),
                            summary: summary,
                            confirmButtonLabel: _.get(translations, 'confirmButtonLabel'),
                            cancelButtonLabel: _.get(translations, 'cancelButtonLabel'),
                            showConfirmationButtons: showConfirmationButtons,
                            formReferenceList: formTemplateReferences
                        };
                    }
                }
            });
            return instance.result;
        });
    };

    this.showServerDisconnectedModal = function () {
        if (!serverDisconnectedModalDisplayed) {
            serverDisconnectedModalDisplayed = true;

            return localization.getTranslations().then(function (translations) {
                let now = moment(),
                    summary = _.replace(_.replace(_.get(translations, 'serverDisconnectedModal.summary'), '${dayOfWeek}', now.format('dddd')), '${time}', now.format('h:mmA')),
                    instance;

                instance = $uibModal.open({
                    templateUrl: '/ui/modal/serverDisconnectedModal/serverDisconnectedModal.tpl.html',
                    controller: 'serverDisconnectedModalController',
                    windowClass: 'serverDisconnectedModal',
                    backdrop: 'static',
                    keyboard: false,
                    resolve: {
                        options: function () {
                            return {
                                title: _.get(translations, 'serverDisconnectedModal.title'),
                                summary: summary,
                                additionalSummary: _.get(translations, 'serverDisconnectedModal.additionalSummary')
                            };
                        }
                    }
                });
                return instance.result.finally(function () {
                    serverDisconnectedModalDisplayed = false;
                });
            });
        } else {
            return $q.when();
        }
    };

    this.showPersistentConnectionFailed = function () {
        localization.getTranslations().then(function (translations) {
            $uibModal.open({
                templateUrl: '/ui/modal/errorModal/errorModal.tpl.html',
                controller: 'errorModalController',
                windowClass: 'genericErrorModal',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    options: function () {
                        return {
                            title: _.get(translations, 'persistentConnectionFailedModal.title'),
                            message: _.get(translations, 'persistentConnectionFailedModal.summary'),
                            okButtonLabel: null
                        };
                    }
                }
            });
        });
    };

    this.isServerDisconnectedModalDisplayed = function () {
        return serverDisconnectedModalDisplayed;
    };

    function startPerformanceLog(logAction, submissionId) {
        if (logAction) {
            let message = !_.isNil(submissionId) ? submissionId.toString() : null;
            $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, logAction, message);
        }
    }

    function stopPerformanceLog(logAction, status) {
        if (logAction) {
            $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, logAction, status);
        }
    }
};
angular.module('umCore')
    .service('modalUtil', ModalUtil);
